import { render } from "./KnowledgeManage.vue?vue&type=template&id=87896926&scoped=true"
import script from "./KnowledgeManage.vue?vue&type=script&lang=js"
export * from "./KnowledgeManage.vue?vue&type=script&lang=js"

import "./KnowledgeManage.vue?vue&type=style&index=0&id=87896926&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87896926"]])

export default __exports__